import React from 'react';
import styles from './index.module.css';
import KpiSection from './kpi/KpiSection';

const Header = () => {
  return (
    <div className={`${styles['header-container']} ${styles['noscr']}`}>
      <KpiSection title="Videos" type="video" />
      <KpiSection title="Notes" type="notes" />
    </div>
  );
};

export default Header;
